<ion-header>
  <ion-toolbar>
    <ion-title>{{action === 'edit'? 'Edit Notes' : getTitle() + 'Notes'}}</ion-title>
    <ion-buttons slot="end">
      <ion-button size="small" fill="solid" color="secondary" (click)="newNote()" *ngIf="action === 'edit'">
        <ion-icon name="add-outline"></ion-icon> {{'general.category' | translate}}
      </ion-button>
      <ion-button (click)="onCancel();">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="etTabsWrapper">
    <nav class="et-tabs" mat-align-tabs="start" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" appHorizontalScroll>
      <a class="tab" cdkDrag [cdkDragDisabled]="activeNoteIndex !== i" *ngFor="let note of editableNotes; let i = index;" (click)="setActiveNote(i)" [class.active]="activeNoteIndex === i"> {{note.title}}
        <span class="action" mat-button [matMenuTriggerFor]="menu" *ngIf="action === 'edit' && activeNoteIndex === i">
          <ion-icon name="ellipsis-vertical-outline"></ion-icon>
        </span>
        <mat-menu #menu="matMenu" yPosition="below">
          <button mat-menu-item (click)="setTitle(i)">{{'general.editTitle' | translate}}</button>
          <button mat-menu-item (click)="duplicateNote(note)">{{'general.duplicateCat' | translate}}</button>
          <button mat-menu-item (click)="deleteNote(i)" *ngIf="editableNotes.length > 1">{{'general.deleteCat' | translate}}</button>
        </mat-menu>
        <span class="moveDiv" *ngIf="activeNoteIndex === i && action === 'edit'">
          <ion-icon name="swap-horizontal-outline"></ion-icon>
        </span>
      </a>
    </nav>
  </div>
  <ion-grid *ngIf="activeNote" class="popupSupplymentContent">
    <ion-row>
      <ion-col>
        <!-- Edit -->
        <div class="note-edit" *ngIf="action === 'edit'">
          <quill-editor name="body" [modules]="editorModules" [(ngModel)]="activeNote.note"></quill-editor>
        </div>

        <!-- View -->
        <div class="note-detail" *ngIf="action !== 'edit'">
          <p [innerHTML]="activeNote.note | safeHtml"></p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="action === 'edit'">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="outline" size="small" class="note-add outlinePlan" *ngIf="defaultNotes && defaultNotes.length > 0" (click)="setDefaultNotes()">{{'general.defaultNotes' | translate}}</ion-button>
      <ion-button color="secondary" fill="solid" size="small" (click)="submitNotes()">
        {{'general.done' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>